/**
 * iurop-whatsapp.js — botón flotante de WhatsApp (Glucody).
 * Estilo "burbuja": el mensajito "¿Te ayudamos?" aparece a los 4s,
 * se cierra con la ✕ y no vuelve a salir en la sesión.
 */
(function () {
  'use strict';

  var KEY = 'glucody-wa-bubble-dismissed';

  function init() {
    var wa = document.querySelector('[data-wa]');
    if (!wa) return;
    var bubble = wa.querySelector('[data-wa-bubble]');
    if (!bubble) return;

    var dismissed = false;
    try {
      dismissed = sessionStorage.getItem(KEY) === '1';
    } catch (e) {}

    if (!dismissed) {
      bubble.hidden = false;
      setTimeout(function () {
        bubble.classList.add('is-visible');
      }, 4000);
    }

    function dismiss() {
      bubble.classList.remove('is-visible');
      try {
        sessionStorage.setItem(KEY, '1');
      } catch (e) {}
    }

    var close = bubble.querySelector('[data-wa-close]');
    if (close) close.addEventListener('click', dismiss);
    // Abrir el chat también retira la burbuja
    var btn = wa.querySelector('.glucody-wa__btn');
    if (btn) btn.addEventListener('click', dismiss);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
